import { render, staticRenderFns } from "./CrearEditarDefinicionConsulta.vue?vue&type=template&id=488f97dc&"
import script from "./CrearEditarDefinicionConsulta.vue?vue&type=script&lang=js&"
export * from "./CrearEditarDefinicionConsulta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports